import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { getEntityById } from "../../api";
import { Box, Typography, Button, Divider, Paper } from "@mui/material";

import { GlobalContext } from "../../GlobalProvider"; // Import GlobalContext
const ViewEntityDef = () => {
  const { id } = useParams();
  const { fullApp } = useContext(GlobalContext); // Get currentApp from GlobalProvider
  const [entity, setEntity] = useState(null);
  const [sensorDetails, setSensorDetails] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEntity = async () => {
      try {
        const response = await getEntityById(id);
        const entity = response.data;

        setEntity(entity);

        const sensorDetailsMap = {};
        const entityType = fullApp?.entities.find((et) => et._id === entity.entityTypeId._id);
        entityType?.sensors.forEach((sensor) => {
          sensorDetailsMap[sensor._id] = sensor;
        });
        setSensorDetails(sensorDetailsMap);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching entity:", error.message);
        setLoading(false);
      }
    };
    if (fullApp)
      fetchEntity();
  }, [id, fullApp]);

  if (loading) return <Typography>Loading...</Typography>;
  if (!entity) return <Typography>Entity not found.</Typography>;

  const generateCurlRequest = (sensor) => {
    const { sensorId, _id: entitySensorId } = sensor;
    const schema = sensorDetails[sensor.sensorId]?.dataSchema || {};

    const dataExample = Object.fromEntries(
      Object.entries(schema.properties || {}).map(([key, value]) => {
        return [key, value.type === "number" ? 0 : "exampleValue"];
      })
    );

    return `curl -X POST 'http://localhost:5000/api/iot-sensor-data/add' \
-H 'Content-Type: application/json' \
-d '{
  "captureTime": "2025-01-01T00:00:00Z",
  "entitySensorId": "${entitySensorId}",
  "sensorId": "${sensorId}",
  "data": ${JSON.stringify(dataExample, null, 2)}
}'`;
  };

  return (
    <Box p={3}>
      <Typography variant="h4">Entity: {entity.name}</Typography>
      <Typography variant="subtitle1">Type: {entity.entityTypeId.name}</Typography>

      <Divider sx={{ my: 2 }} />

      <Typography variant="h5">Sensors</Typography>
      {entity.sensors.length > 0 ? (
        entity.sensors.map((sensor) => (
          <Paper elevation={3} sx={{ p: 2, my: 2 }} key={sensor._id}>
            <Typography variant="h6">Sensor: {sensor.externalId}</Typography>
            <Typography>Sensor ID: {sensor.sensorId}</Typography>
            <Typography>Data Schema:</Typography>
            <pre>{JSON.stringify(sensorDetails[sensor.sensorId]?.dataSchema || {}, null, 2)}</pre>
            <Typography variant="body1">Sample CURL Request:</Typography>
            <pre>{generateCurlRequest(sensor)}</pre>
          </Paper>
        ))
      ) : (
        <Typography>No sensors available for this entity.</Typography>
      )}
    </Box>
  );
};

export default ViewEntityDef;
